import type { TOrganizationTypes } from '@sravni/ugc/lib/organizations/types';
import { OrganizationTypes } from '@sravni/ugc/lib/organizations/types';

export const PAGE_ROUTE_TO_ORGANIZATION_TYPE_MAP: Record<string, TOrganizationTypes> = {
  'strakhovye-kompanii': OrganizationTypes.Insurance,
  banki: OrganizationTypes.Bank,
  zaimy: OrganizationTypes.Mfo,
  kursy: OrganizationTypes.EducationalOrganization,
  brokery: OrganizationTypes.Broker,
  npf: OrganizationTypes.Npf,
  leasing: OrganizationTypes.Leasing,
  marketplace: OrganizationTypes.Marketplace,
  bankruptcy: OrganizationTypes.Bankruptcy,
  university: OrganizationTypes.University,
  bukmekery: OrganizationTypes.Bookmaker,
  'raciony-kompanii': OrganizationTypes.FoodRation,
};

export const OrganizationTypeToOrganizationReviewsMap: Record<TOrganizationTypes, string> = {
  [OrganizationTypes.Bank]: 'bank',
  [OrganizationTypes.Insurance]: 'strakhovaja-kompanija',
  [OrganizationTypes.Mfo]: 'zaimy/mfo',
  [OrganizationTypes.EducationalOrganization]: 'shkola',
  [OrganizationTypes.Broker]: 'broker',
  [OrganizationTypes.Npf]: 'npf',
  [OrganizationTypes.Leasing]: 'leasing',
  [OrganizationTypes.Marketplace]: 'marketplace',
  [OrganizationTypes.Bankruptcy]: 'bankruptcy',
  [OrganizationTypes.University]: 'university',
  [OrganizationTypes.Bookmaker]: 'bukmeker',
  [OrganizationTypes.FoodRation]: 'raciony-kompanii',
};
